import Vue from 'vue'

let eventHub = new Vue()

export default eventHub
